(function () {
  var STORAGE_KEY = 'um_selected_model';
  var GAP = 24;
  var OFFSET_WIDE = 92;
  var OFFSET_NARROW = 140;

  var COMPAT_PARAM = 'filter.p.m.custom.compatible_models';

  document.documentElement.classList.add('facets-auto');

  function facetsEl() { return document.querySelector('.facets'); }
  function gridEl() { return document.querySelector('.collection__grid'); }
  function facetsForm() {
    return document.getElementById('FacetsForm') || document.getElementById('SearchFacetsForm');
  }

  function syncSticky() {
    var el = facetsEl();
    if (!el) return;
    if (window.innerWidth < 901) { el.style.removeProperty('--facets-top'); return; }
    var offset = window.innerWidth >= 1060 ? OFFSET_WIDE : OFFSET_NARROW;
    var h = el.offsetHeight;
    var vh = window.innerHeight;
    var top = (h + offset + GAP <= vh) ? offset : (vh - h - GAP);
    el.style.setProperty('--facets-top', Math.round(top) + 'px');
  }

  function urlCompatValues() {
    var out = [];
    var qs = String(window.location.search || '').replace(/^\\?/, '');
    qs.split('&').forEach(function (pair) {
      if (!pair) return;
      var i = pair.indexOf('=');
      var rawKey = i < 0 ? pair : pair.slice(0, i);
      var rawVal = i < 0 ? '' : pair.slice(i + 1);
      var key, val;
      try {
        key = decodeURIComponent(rawKey.replace(/\\+/g, ' '));
        val = decodeURIComponent(rawVal.replace(/\\+/g, ' '));
      } catch (e) { return; }
      if (key === COMPAT_PARAM && val) out.push(val);
    });
    return out;
  }

  /* Libellé du bandeau : modèle précis, ou « Marque (tous modèles) »
     quand le filtre couvre toute la marque. */
  function compatLabel(values) {
    if (!values.length) return '';
    var data = vehicleData();
    var matched = null;
    for (var i = 0; i < data.models.length; i++) {
      if (data.models[i].values.indexOf(values[0]) !== -1) { matched = data.models[i]; break; }
    }
    if (!matched) return values[0];
    if (values.length > matched.values.length) return matched.brand + ' (tous modèles)';
    return matched.model;
  }

  function ensureBanner(values) {
    var header = document.querySelector('.collection__header');
    if (!header) return;
    var existing = header.querySelector('.active-model-banner');
    if (!values.length) {
      if (existing && existing.getAttribute('data-compat-banner') !== null) existing.remove();
      return;
    }
    if (existing) return;

    var el = document.createElement('div');
    el.className = 'active-model-banner';
    el.setAttribute('data-compat-banner', '');

    var span = document.createElement('span');
    span.appendChild(document.createTextNode('Pièces compatibles avec : '));
    var strong = document.createElement('strong');
    strong.textContent = compatLabel(values);
    span.appendChild(strong);

    var link = document.createElement('a');
    link.href = window.location.pathname;
    link.textContent = 'Voir toutes les pièces';

    el.appendChild(span);
    el.appendChild(link);
    header.appendChild(el);
  }

  function syncCompatScope() {
    var wanted = urlCompatValues();
    var form = facetsForm();

    if (form) {
      var present = [];
      form.querySelectorAll('input[name=\"' + COMPAT_PARAM + '\"]').forEach(function (el) {
        if (el.type === 'checkbox' && !el.checked) return;
        present.push(el.value);
      });
      wanted.forEach(function (v) {
        if (present.indexOf(v) !== -1) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = COMPAT_PARAM;
        input.value = v;
        input.setAttribute('data-compat-scope', '');
        form.appendChild(input);
        present.push(v);
      });
    }

    var clear = document.querySelector('.facets__clear');
    if (clear && wanted.length) {
      var base = String(clear.getAttribute('href') || window.location.pathname).split('?')[0];
      clear.setAttribute('href', base + '?' + wanted.map(function (v) {
        return COMPAT_PARAM + '=' + encodeURIComponent(v);
      }).join('&'));
    }

    ensureBanner(wanted);
  }

  /* ---------------------------------------------------------------
     WIDGET « VOTRE VÉHICULE » — cascade marque → modèle.
     Option « Tous les modèles X » = filtre sur toutes les valeurs de la
     marque (le client marque-seule ne voit que sa marque).
     --------------------------------------------------------------- */
  var vehicleDataCache = null;
  function vehicleData() {
    if (vehicleDataCache) return vehicleDataCache;
    var data = { models: [] };
    var el = document.getElementById('ModelFinderData');
    if (el) {
      try {
        var p = JSON.parse(el.textContent);
        data.models = p.models || [];
      } catch (e) {}
    }
    var ov = document.getElementById('ModelFinderOverrides');
    if (ov) {
      try {
        var o = JSON.parse(ov.textContent) || {};
        if (o.extraModels && o.extraModels.length) {
          o.extraModels.forEach(function (m) { data.models.push(m); });
        }
        if (o.aliases) {
          data.models.forEach(function (m) {
            var extra = o.aliases[m.model];
            if (extra && extra.length) {
              m.values = (m.values && m.values.length ? m.values : [m.model]).concat(extra);
            }
          });
        }
      } catch (e) {}
    }
    data.models.forEach(function (m) {
      if (!m.values || !m.values.length) m.values = [m.model];
    });
    vehicleDataCache = data;
    return data;
  }

  function setGarage(entry) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        type: entry.type, brand: entry.brand, brandHandle: entry.brandHandle,
        model: entry.model, tag: entry.tag || entry.model, tagHandle: entry.tagHandle,
        values: entry.values
      }));
    } catch (e) {}
  }

  function applyCompatValues(values) {
    var form = facetsForm();
    if (!form) return;
    form.querySelectorAll('input[name=\"' + COMPAT_PARAM + '\"]').forEach(function (el) { el.remove(); });
    (values || []).forEach(function (v) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = COMPAT_PARAM;
      input.value = v;
      form.appendChild(input);
    });
    applyFilters(form);
  }

  function modelsForBrand(handle) {
    return vehicleData().models.filter(function (m) { return m.brandHandle === handle; })
      .sort(function (a, b) { return a.model.localeCompare(b.model, 'fr', { numeric: true }); });
  }

  function brandUnionValues(models) {
    var out = [];
    models.forEach(function (m) {
      (m.values || [m.model]).forEach(function (v) {
        if (out.indexOf(v) === -1) out.push(v);
      });
    });
    return out;
  }

  function fillModelSelect(mSel, models, brandLabel) {
    mSel.innerHTML = '';
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = 'Modèle…';
    mSel.appendChild(ph);
    if (models.length) {
      var all = document.createElement('option');
      all.value = '__all';
      all.textContent = 'Tous les modèles' + (brandLabel ? ' ' + brandLabel : '');
      mSel.appendChild(all);
    }
    models.forEach(function (m, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = m.model;
      mSel.appendChild(opt);
    });
    mSel.disabled = models.length === 0;
  }

  function initVehicleWidget() {
    var box = document.querySelector('[data-vehicle-filter]');
    if (!box) return;
    var data = vehicleData();
    if (!data.models.length) { box.hidden = true; return; }

    var bSel = box.querySelector('[data-vf-brand]');
    var mSel = box.querySelector('[data-vf-model]');
    var clearBtn = box.querySelector('[data-vf-clear]');
    if (!bSel || !mSel) return;

    var brandsSeen = {};
    var brands = [];
    data.models.forEach(function (m) {
      if (!brandsSeen[m.brandHandle]) {
        brandsSeen[m.brandHandle] = true;
        brands.push({ handle: m.brandHandle, label: m.brand });
      }
    });
    brands.sort(function (a, b) { return a.label.localeCompare(b.label, 'fr'); });

    bSel.innerHTML = '';
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = 'Marque…';
    bSel.appendChild(ph);
    brands.forEach(function (b) {
      var opt = document.createElement('option');
      opt.value = b.handle;
      opt.textContent = b.label;
      bSel.appendChild(opt);
    });

    box.__vfModels = [];

    function selectBrand(handle, label) {
      bSel.value = handle || '';
      var models = handle ? modelsForBrand(handle) : [];
      box.__vfModels = models;
      fillModelSelect(mSel, models, label || '');
    }

    var active = urlCompatValues();
    var preset = null;
    if (active.length) {
      for (var i = 0; i < data.models.length; i++) {
        if (data.models[i].values.indexOf(active[0]) !== -1) { preset = data.models[i]; break; }
      }
    }
    if (!preset && !active.length) {
      try {
        var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        if (saved && saved.tagHandle) {
          for (var j = 0; j < data.models.length; j++) {
            if (data.models[j].tagHandle === saved.tagHandle) { preset = data.models[j]; break; }
          }
        }
      } catch (e) {}
    }

    if (preset) {
      selectBrand(preset.brandHandle, preset.brand);
      if (active.length > preset.values.length) {
        mSel.value = '__all';
      } else {
        var models = box.__vfModels;
        for (var k = 0; k < models.length; k++) {
          if (models[k].tagHandle === preset.tagHandle) { mSel.value = String(k); break; }
        }
      }
    } else {
      selectBrand('', '');
    }

    if (clearBtn) { clearBtn.hidden = active.length === 0; }
    box.hidden = false;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var box = t.closest('[data-vehicle-filter]');
    if (box) {
      if (t.hasAttribute('data-vf-brand')) {
        var mSel = box.querySelector('[data-vf-model]');
        var models = t.value ? modelsForBrand(t.value) : [];
        var label = t.value && t.selectedIndex > 0 ? t.options[t.selectedIndex].textContent : '';
        box.__vfModels = models;
        fillModelSelect(mSel, models, label);
        return;
      }
      if (t.hasAttribute('data-vf-model')) {
        var list = box.__vfModels || [];
        if (t.value === '__all') {
          if (list.length) { applyCompatValues(brandUnionValues(list)); }
          return;
        }
        var idx = parseInt(t.value, 10);
        var entry = list[idx];
        if (entry) {
          setGarage(entry);
          applyCompatValues(entry.values);
        }
        return;
      }
      return;
    }

    var form = t.closest('#FacetsForm, #SearchFacetsForm');
    if (!form) return;
    applyFilters(form);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vf-clear]');
    if (!btn) return;
    e.preventDefault();
    applyCompatValues([]);
  });

  function upgradeCompatBadges(root) {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) {}
    (root || document).querySelectorAll('[data-compat-badge]').forEach(function (el) {
      var tags = (el.getAttribute('data-compat-tags') || '').split('|');
      var match = false;
      if (saved) {
        if (saved.tag && tags.indexOf(saved.tag) !== -1) match = true;
        if (!match && saved.values && saved.values.length) {
          for (var i = 0; i < saved.values.length; i++) {
            if (tags.indexOf(saved.values[i]) !== -1) { match = true; break; }
          }
        }
      }
      if (match) {
        el.textContent = '✓ Compatible ' + saved.model;
        el.classList.add('product-card__fit--match');
      } else {
        el.textContent = el.getAttribute('data-default-text');
        el.classList.remove('product-card__fit--match');
      }
    });
  }

  function buildUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== null && String(value).trim() !== '') params.append(key, value);
    });
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function fetchAndSwap(url) {
    var el = facetsEl();
    if (el) el.classList.add('facets--loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.collection__grid');
        var newFacets = doc.querySelector('.facets');
        var curGrid = gridEl();
        var curFacets = facetsEl();

        if (newGrid && curGrid) {
          curGrid.innerHTML = newGrid.innerHTML;
          curGrid.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (e) {
            e.classList.add('is-visible');
          });
          upgradeCompatBadges(curGrid);
        }
        if (newFacets && curFacets) {
          var scrolled = curFacets.scrollTop;
          curFacets.innerHTML = newFacets.innerHTML;
          curFacets.scrollTop = scrolled;
          curFacets.classList.remove('facets--loading');
        }

        window.history.replaceState({}, '', url);
        syncCompatScope();
        initVehicleWidget();
        syncSticky();
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  function applyFilters(form) {
    fetchAndSwap(buildUrl(form));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || (form.id !== 'FacetsForm' && form.id !== 'SearchFacetsForm')) return;
    e.preventDefault();
    applyFilters(form);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.facets__clear');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    e.preventDefault();
    fetchAndSwap(href);
  });

  window.addEventListener('resize', syncSticky);
  document.addEventListener('DOMContentLoaded', function () {
    syncCompatScope();
    initVehicleWidget();
    syncSticky();
    setTimeout(syncSticky, 400);
  });
})();